import { createContext, PropsWithChildren } from 'react';
import { RhinoResource } from '../../index';

export interface ModelContextValue {
  model?: RhinoResource;
  [key: string]: unknown;
}

export const ModelContext = createContext<ModelContextValue | undefined>(
  undefined
);

export const ModelProvider = ({
  children,
  ...props
}: PropsWithChildren<ModelContextValue>) => {
  return <ModelContext value={{ ...props }}>{children}</ModelContext>;
};
